<template>
  <div>
    <div>
      <div class="c-card-body">
        <datatable
          ref="datatable"
          module="paid-trial-class"
          :title="title"
          :url="url"
          :columns="columns"
          :on-click-create="onClickCreate"
          :on-click-update="onClickUpdate"
          :on-click-delete="onClickDelete"
          :action-width="180"
        >
        <template v-slot:[`item.created_at`]="{ item }">
            <div v-if="item.created_at != null">
              {{ item.created_at | moment("DD/MM/YYYY") }}
            </div>
            <div v-else>-</div>
        </template>
        <template v-slot:[`item.status`]="{ item }">
            <v-chip
              :color="item.status === 'verified' ? 'green' : item.status === 'unverified' ? 'red' : 'blue'"
              text-color="white"
              small
            >
              {{ item.status.charAt(0).toUpperCase() + item.status.slice(1) }}
            </v-chip>
        </template>
        <template v-slot:[`item.price`]="{ item }">
            <div>
              Rp {{ new Intl.NumberFormat("id-ID").format(item.price) }}
            </div>
          </template>
      </datatable>
      </div>
    </div>
    <form-action ref="form" module="paid-trial-class" :success="formSuccess" />
    <delete-dialog
      ref="delete"
      url="paid-trial-class"
      :success="deleteSuccess"
    ></delete-dialog>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Datatable from "@/view/component/Datatable.vue";
import DeleteDialog from "@/view/component/DeleteDialog.vue";
import FormAction from "./Form";

export default {
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Manajemen Member", route: "" },
      { title: "Kelas Percobaan Berbayar" }
    ]);
  },
  data() {
    return {
      title: "Kelas Percobaan Berbayar",
      url: "paid-trial-class/data",
      columns: [
        {
          value: "id"
        },
        {
          text: "non member",
          value: "non_member_name",
          sortable: true,
          searchable: true
        },
        {
          text: "member",
          value: "member_name",
          sortable: true,
          searchable: true
        },
        {
          text: "Kelas",
          value: "class_type_name",
          sortable: true,
          searchable: false
        },
        {
          text: "Jadwal Kelas",
          value: "class_date",
          sortable: true,
          searchable: false
        },
        {
          text: "Jam Mulai",
          value: "start_time",
          sortable: true,
          searchable: false
        },
        {
          text: "Jam Selesai",
          value: "end_time",
          sortable: true,
          searchable: false
        },

        {
          text: "Tanggal",
          value: "created_at",
          sortable: true,
          searchable: false,
          formatter: (value) => {
            return value ? this.$moment(value).format("DD/MM/YYYY") : "";
          }
        },
        {
          text: "Harga",
          value: "price",
          sortable: true,
          searchable: false,
        },
        {
          text: "Deskripsi",
          value: "description",
          sortable: true,
          searchable: true
        },
      ]
    };
  },
  methods: {
    onClickCreate() {
      this.$refs.form.open();
    },
    onClickUpdate(item) {
      this.$refs.form.open(item.id);
    },
    onClickDelete(item) {
      this.$refs.delete.open(item.id);
    },
    formSuccess() {
      this.$refs.datatable.getData();
    },
    deleteSuccess() {
      this.$refs.datatable.getData();
    }
  },
  components: {
    Datatable,
    DeleteDialog,
    FormAction
  }
};
</script>
